import { render, staticRenderFns } from "./jobs.vue?vue&type=template&id=191a959d&scoped=true&"
import script from "./jobs.vue?vue&type=script&lang=ts&"
export * from "./jobs.vue?vue&type=script&lang=ts&"
import style0 from "./jobs.vue?vue&type=style&index=0&id=191a959d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "191a959d",
  null
  
)

export default component.exports